import Permissions from 'src/security/permissions';

const permissions = Permissions.values;

const privateRoutes = [
  {
    path: '/',
    loader: () =>
      import('src/view/dashboard/DashboardPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/profile',
    loader: () => import('src/view/auth/ProfileFormPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/password-change',
    loader: () =>
      import('src/view/auth/PasswordChangeFormPage'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/api-key',
    loader: () =>
      import('src/view/apiKey/list/ApiKeyListPage'),
    permissionRequired: permissions.apiKeyRead,
    exact: true,
  },
  {
    path: '/api-key/new',
    loader: () =>
      import('src/view/apiKey/form/ApiKeyFormPage'),
    permissionRequired: permissions.apiKeyCreate,
    exact: true,
  },
  {
    path: '/api-key/importer',
    loader: () =>
      import('src/view/apiKey/importer/ApiKeyImporterPage'),
    permissionRequired: permissions.apiKeyImport,
    exact: true,
  },
  {
    path: '/api-key/:id/edit',
    loader: () =>
      import('src/view/apiKey/form/ApiKeyFormPage'),
    permissionRequired: permissions.apiKeyEdit,
    exact: true,
  },
  {
    path: '/api-key/:id',
    loader: () =>
      import('src/view/apiKey/view/ApiKeyViewPage'),
    permissionRequired: permissions.apiKeyRead,
    exact: true,
  },

  {
    path: '/app-user',
    loader: () =>
      import('src/view/appUser/list/AppUserListPage'),
    permissionRequired: permissions.appUserRead,
    exact: true,
  },
  {
    path: '/app-user/new',
    loader: () =>
      import('src/view/appUser/form/AppUserFormPage'),
    permissionRequired: permissions.appUserCreate,
    exact: true,
  },
  {
    path: '/app-user/importer',
    loader: () =>
      import(
        'src/view/appUser/importer/AppUserImporterPage'
      ),
    permissionRequired: permissions.appUserImport,
    exact: true,
  },
  {
    path: '/app-user/:id/edit',
    loader: () =>
      import('src/view/appUser/form/AppUserFormPage'),
    permissionRequired: permissions.appUserEdit,
    exact: true,
  },
  {
    path: '/app-user/:id',
    loader: () =>
      import('src/view/appUser/view/AppUserViewPage'),
    permissionRequired: permissions.appUserRead,
    exact: true,
  },
  {
    path: `/dashboard-studio/:dashboardId`,
    loader: () =>
      import('src/view/dashboard/DashboardDataStudio'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/tenant',
    loader: () =>
      import('src/view/tenant/list/TenantListPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/tenant/new',
    loader: () =>
      import('src/view/tenant/form/TenantFormPage'),
    permissionRequired: null,
    exact: true,
  },
  {
    path: '/tenant/:id/edit',
    loader: () =>
      import('src/view/tenant/form/TenantFormPage'),
    permissionRequired: null,
    exact: true,
  },

  {
    path: '/user',
    loader: () => import('src/view/user/list/UserPage'),
    permissionRequired: permissions.userRead,
    exact: true,
  },

  {
    path: '/user/new',
    loader: () => import('src/view/user/new/UserNewPage'),
    permissionRequired: permissions.userCreate,
    exact: true,
  },

  {
    path: '/user/importer',
    loader: () =>
      import('src/view/user/importer/UserImporterPage'),
    permissionRequired: permissions.userImport,
    exact: true,
  },
  {
    path: '/user/:id/edit',
    loader: () => import('src/view/user/edit/UserEditPage'),
    permissionRequired: permissions.userEdit,
    exact: true,
  },
  {
    path: '/user/:id',
    loader: () => import('src/view/user/view/UserViewPage'),
    permissionRequired: permissions.userRead,
    exact: true,
  },

  {
    path: '/audit-logs',
    loader: () => import('src/view/auditLog/AuditLogPage'),
    permissionRequired: permissions.auditLogRead,
  },

  {
    path: '/settings',
    loader: () =>
      import('src/view/settings/SettingsFormPage'),
    permissionRequired: permissions.settingsEdit,
  },

  {
    path: '/location',
    loader: () =>
      import('src/view/location/list/LocationListPage'),
    permissionRequired: permissions.locationRead,
    exact: true,
  },
  {
    path: '/location/new',
    loader: () =>
      import('src/view/location/form/LocationFormPage'),
    permissionRequired: permissions.locationCreate,
    exact: true,
  },
  {
    path: '/location/importer',
    loader: () =>
      import(
        'src/view/location/importer/LocationImporterPage'
      ),
    permissionRequired: permissions.locationImport,
    exact: true,
  },
  {
    path: '/location/:id/edit',
    loader: () =>
      import('src/view/location/form/LocationFormPage'),
    permissionRequired: permissions.locationEdit,
    exact: true,
  },
  {
    path: '/location/:id',
    loader: () =>
      import('src/view/location/view/LocationViewPage'),
    permissionRequired: permissions.locationRead,
    exact: true,
  },

  {
    path: '/resource',
    loader: () =>
      import('src/view/resource/list/ResourceListPage'),
    permissionRequired: permissions.resourceRead,
    exact: true,
  },
  {
    path: '/resource/view/:id/:title',
    loader: () =>
      import('src/view/resource/list/ResourceListPage'),
    permissionRequired: permissions.resourceRead,
    exact: true,
  },

  {
    path: '/resource/new',
    loader: () =>
      import('src/view/resource/form/ResourceFormPage'),
    permissionRequired: permissions.resourceCreate,
    exact: true,
  },
  {
    path: '/resource/importer',
    loader: () =>
      import(
        'src/view/resource/importer/ResourceImporterPage'
      ),
    permissionRequired: permissions.resourceImport,
    exact: true,
  },
  {
    path: '/resource/:id/edit',
    loader: () =>
      import('src/view/resource/form/ResourceFormPage'),
    permissionRequired: permissions.resourceEdit,
    exact: true,
  },
  {
    path: '/keyword',
    loader: () =>
      import('src/view/keyword/list/KeywordListPage'),
    permissionRequired: permissions.keywordRead,
    exact: true,
  },
  {
    path: '/keyword/new',
    loader: () =>
      import('src/view/keyword/form/KeywordFormPage'),
    permissionRequired: permissions.keywordCreate,
    exact: true,
  },
  {
    path: '/keyword/importer',
    loader: () =>
      import(
        'src/view/keyword/importer/KeywordImporterPage'
      ),
    permissionRequired: permissions.keywordImport,
    exact: true,
  },
  {
    path: '/keyword/:id/edit',
    loader: () =>
      import('src/view/keyword/form/KeywordFormPage'),
    permissionRequired: permissions.keywordEdit,
    exact: true,
  },
  {
    path: '/keyword/:id',
    loader: () =>
      import('src/view/keyword/view/KeywordViewPage'),
    permissionRequired: permissions.keywordRead,
    exact: true,
  },

  {
    path: '/form-category',
    loader: () =>
      import(
        'src/view/formCategory/list/FormCategoryListPage'
      ),
    permissionRequired: permissions.formCategoryRead,
    exact: true,
  },
  {
    path: '/form-category/new',
    loader: () =>
      import(
        'src/view/formCategory/form/FormCategoryFormPage'
      ),
    permissionRequired: permissions.formCategoryCreate,
    exact: true,
  },
  {
    path: '/form-category/importer',
    loader: () =>
      import(
        'src/view/formCategory/importer/FormCategoryImporterPage'
      ),
    permissionRequired: permissions.formCategoryImport,
    exact: true,
  },
  {
    path: '/form-category/:id/edit',
    loader: () =>
      import(
        'src/view/formCategory/form/FormCategoryFormPage'
      ),
    permissionRequired: permissions.formCategoryEdit,
    exact: true,
  },
  {
    path: '/form-category/:id',
    loader: () =>
      import(
        'src/view/formCategory/view/FormCategoryViewPage'
      ),
    permissionRequired: permissions.formCategoryRead,
    exact: true,
  },

  {
    path: '/asset',
    loader: () =>
      import('src/view/asset/list/AssetListPage'),
    permissionRequired: permissions.assetRead,
    exact: true,
  },
  {
    path: '/asset/new',
    loader: () =>
      import('src/view/asset/form/AssetFormPage'),
    permissionRequired: permissions.assetCreate,
    exact: true,
  },
  {
    path: '/asset/importer',
    loader: () =>
      import('src/view/asset/importer/AssetImporterPage'),
    permissionRequired: permissions.assetImport,
    exact: true,
  },
  {
    path: '/asset/:id/edit',
    loader: () =>
      import('src/view/asset/form/AssetFormPage'),
    permissionRequired: permissions.assetEdit,
    exact: true,
  },
  {
    path: '/asset/:id',
    loader: () =>
      import('src/view/asset/view/AssetViewPage'),
    permissionRequired: permissions.assetRead,
    exact: true,
  },

  {
    path: '/notification',
    loader: () =>
      import(
        'src/view/notification/list/NotificationListPage'
      ),
    permissionRequired: permissions.notificationRead,
    exact: true,
  },
  {
    path: '/notification/new',
    loader: () =>
      import(
        'src/view/notification/form/NotificationFormPage'
      ),
    permissionRequired: permissions.notificationCreate,
    exact: true,
  },
  {
    path: '/notification/importer',
    loader: () =>
      import(
        'src/view/notification/importer/NotificationImporterPage'
      ),
    permissionRequired: permissions.notificationImport,
    exact: true,
  },
  {
    path: '/notification/:id/edit',
    loader: () =>
      import(
        'src/view/notification/form/NotificationFormPage'
      ),
    permissionRequired: permissions.notificationEdit,
    exact: true,
  },
  {
    path: '/notification/:id',
    loader: () =>
      import(
        'src/view/notification/view/NotificationViewPage'
      ),
    permissionRequired: permissions.notificationRead,
    exact: true,
  },

  {
    path: '/form-template',
    loader: () =>
      import(
        'src/view/formTemplate/list/FormTemplateListPage'
      ),
    permissionRequired: permissions.formTemplateRead,
    exact: true,
  },
  {
    path: '/form-template/new',
    loader: () =>
      import(
        'src/view/formTemplate/form/FormTemplateFormPage'
      ),
    permissionRequired: permissions.formTemplateCreate,
    exact: true,
  },
  {
    path: '/form-template/importer',
    loader: () =>
      import(
        'src/view/formTemplate/importer/FormTemplateImporterPage'
      ),
    permissionRequired: permissions.formTemplateImport,
    exact: true,
  },
  {
    path: '/form-template/:id/edit',
    loader: () =>
      import(
        'src/view/formTemplate/form/FormTemplateFormPage'
      ),
    permissionRequired: permissions.formTemplateEdit,
    exact: true,
  },
  {
    path: '/form-template/:id/builder',
    loader: () =>
      import(
        'src/view/formTemplate/form/FormTemplateBuilderPage'
      ),
    permissionRequired: permissions.formTemplateEdit,
    exact: true,
  },
  {
    path: '/form-template/:id',
    loader: () =>
      import(
        'src/view/formTemplate/view/FormTemplateViewPage'
      ),
    permissionRequired: permissions.formTemplateRead,
    exact: true,
  },

  {
    path: '/workflow',
    loader: () =>
      import('src/view/workflow/list/WorkflowListPage'),
    permissionRequired: permissions.workflowRead,
    exact: true,
  },
  {
    path: '/workflow/new',
    loader: () =>
      import('src/view/workflow/form/WorkflowFormPage'),
    permissionRequired: permissions.workflowCreate,
    exact: true,
  },
  {
    path: '/workflow/importer',
    loader: () =>
      import(
        'src/view/workflow/importer/WorkflowImporterPage'
      ),
    permissionRequired: permissions.workflowImport,
    exact: true,
  },
  {
    path: '/workflow/:id/edit',
    loader: () =>
      import('src/view/workflow/form/WorkflowFormPage'),
    permissionRequired: permissions.workflowEdit,
    exact: true,
  },
  {
    path: '/workflow/:id',
    loader: () =>
      import('src/view/workflow/view/WorkflowViewPage'),
    permissionRequired: permissions.workflowRead,
    exact: true,
  },

  {
    path: '/flow-step',
    loader: () =>
      import('src/view/flowStep/list/FlowStepListPage'),
    permissionRequired: permissions.flowStepRead,
    exact: true,
  },
  {
    path: '/flow-step/new',
    loader: () =>
      import('src/view/flowStep/form/FlowStepFormPage'),
    permissionRequired: permissions.flowStepCreate,
    exact: true,
  },
  {
    path: '/flow-step/importer',
    loader: () =>
      import(
        'src/view/flowStep/importer/FlowStepImporterPage'
      ),
    permissionRequired: permissions.flowStepImport,
    exact: true,
  },
  {
    path: '/flow-step/:id/edit',
    loader: () =>
      import('src/view/flowStep/form/FlowStepFormPage'),
    permissionRequired: permissions.flowStepEdit,
    exact: true,
  },
  {
    path: '/flow-step/:id',
    loader: () =>
      import('src/view/flowStep/view/FlowStepViewPage'),
    permissionRequired: permissions.flowStepRead,
    exact: true,
  },

  {
    path: '/workflow-launch',
    loader: () =>
      import(
        'src/view/workflowLaunch/list/WorkflowLaunchListPage'
      ),
    permissionRequired: permissions.workflowLaunchRead,
    exact: true,
  },
  {
    path: '/workflow-launch/new',
    loader: () =>
      import(
        'src/view/workflowLaunch/form/WorkflowLaunchFormPage'
      ),
    permissionRequired: permissions.workflowLaunchCreate,
    exact: true,
  },
  {
    path: '/workflow-launch/importer',
    loader: () =>
      import(
        'src/view/workflowLaunch/importer/WorkflowLaunchImporterPage'
      ),
    permissionRequired: permissions.workflowLaunchImport,
    exact: true,
  },
  {
    path: '/workflow-launch/:id/edit',
    loader: () =>
      import(
        'src/view/workflowLaunch/form/WorkflowLaunchFormPage'
      ),
    permissionRequired: permissions.workflowLaunchEdit,
    exact: true,
  },
  {
    path: '/workflow-launch/:id',
    loader: () =>
      import(
        'src/view/workflowLaunch/view/WorkflowLaunchViewPage'
      ),
    permissionRequired: permissions.workflowLaunchRead,
    exact: true,
  },

  {
    path: '/data-studio',
    loader: () =>
      import('src/view/dataStudio/list/DataStudioListPage'),
    permissionRequired: permissions.dataStudioRead,
    exact: true,
  },
  {
    path: '/data-studio/new',
    loader: () =>
      import('src/view/dataStudio/form/DataStudioFormPage'),
    permissionRequired: permissions.dataStudioCreate,
    exact: true,
  },
  {
    path: '/data-studio/importer',
    loader: () =>
      import(
        'src/view/dataStudio/importer/DataStudioImporterPage'
      ),
    permissionRequired: permissions.dataStudioImport,
    exact: true,
  },
  {
    path: '/data-studio/:id/edit',
    loader: () =>
      import('src/view/dataStudio/form/DataStudioFormPage'),
    permissionRequired: permissions.dataStudioEdit,
    exact: true,
  },
  {
    path: '/data-studio/:id',
    loader: () =>
      import('src/view/dataStudio/view/DataStudioViewPage'),
    permissionRequired: permissions.dataStudioRead,
    exact: true,
  },

  {
    path: '/indicator',
    loader: () =>
      import('src/view/indicator/list/IndicatorListPage'),
    permissionRequired: permissions.indicatorRead,
    exact: true,
  },
  {
    path: '/indicator/new',
    loader: () =>
      import('src/view/indicator/form/IndicatorFormPage'),
    permissionRequired: permissions.indicatorCreate,
    exact: true,
  },
  {
    path: '/indicator/importer',
    loader: () =>
      import(
        'src/view/indicator/importer/IndicatorImporterPage'
      ),
    permissionRequired: permissions.indicatorImport,
    exact: true,
  },
  {
    path: '/indicator/:id/edit',
    loader: () =>
      import('src/view/indicator/form/IndicatorFormPage'),
    permissionRequired: permissions.indicatorEdit,
    exact: true,
  },
  {
    path: '/indicator/:id',
    loader: () =>
      import('src/view/indicator/view/IndicatorViewPage'),
    permissionRequired: permissions.indicatorRead,
    exact: true,
  },
].filter(Boolean);

const publicRoutes = [
  {
    path: '/auth/signin',
    loader: () => import('src/view/auth/SigninPage'),
    exact: true,
  },
  {
    path: '/auth/signup',
    loader: () => import('src/view/auth/SignupPage'),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    loader: () =>
      import('src/view/auth/ForgotPasswordPage'),
    exact: true,
  },
];

const emptyTenantRoutes = [
  {
    path: '/auth/tenant',
    loader: () => import('src/view/auth/TenantPage'),
    exact: true,
  },
];

const emptyPermissionsRoutes = [
  {
    path: '/auth/empty-permissions',
    loader: () =>
      import('src/view/auth/EmptyPermissionsPage'),
    exact: true,
  },
];

const emailUnverifiedRoutes = [
  {
    path: '/auth/email-unverified',
    loader: () =>
      import('src/view/auth/EmailUnverifiedPage'),
    exact: true,
  },
];

const simpleRoutes = [
  {
    path: '/resource/:id',
    loader: () =>
      import('src/view/resource/view/ResourceViewPage'),
  },
  {
    path: '/auth/password-reset',
    loader: () => import('src/view/auth/PasswordResetPage'),
    exact: true,
  },
  {
    path: '/auth/invitation',
    loader: () => import('src/view/auth/InvitationPage'),
  },
  {
    path: '/auth/verify-email',
    loader: () => import('src/view/auth/VerifyEmailPage'),
    exact: true,
  },
  {
    path: '/403',
    loader: () =>
      import('src/view/shared/errors/Error403Page'),
  },
  {
    path: '/500',
    loader: () =>
      import('src/view/shared/errors/Error500Page'),
  },
  {
    path: '*/*',
    loader: () =>
      import('src/view/shared/errors/Error404Page'),
    exact: true,
  },
].filter(Boolean);

export default {
  privateRoutes,
  publicRoutes,
  emptyTenantRoutes,
  emptyPermissionsRoutes,
  emailUnverifiedRoutes,
  simpleRoutes,
};
